import React,{useState} from 'react'
import {Box,Typography} from '@mui/material'
import css from '../../css/login.module.css';
import { Link } from 'react-router-dom';
import { apiFormRequest } from '../../api';
import { NotificationContext } from "../../providers/notification";
import {useContext} from 'react'
import {MdOutlineMailOutline as EmailIcons} from 'react-icons/md'



const ForgotPassword = () => {
  const [Email,setEmail] = useState<any>('');
  const { showNotification } = useContext(NotificationContext);
const lightText:string = "#D2EAE1";
  const handleSubmit = (e:any) =>{
    e.preventDefault();
    if(Email){
        const body = new FormData();
        body.append('Email',Email);
        const isAdmin = true.toString();
        body.append('IsAdmin',isAdmin);
        apiFormRequest('api/Authentication/ForgotPasswordAsync',body)
        .then(data => {
          if(data.StatusCode == 200){
            showNotification({
              message:data.Message ||  'reset password sent to your email successfully',
              type: "success",
            })
    
          }
          else{
            showNotification({
              message:data.Message || 'Try again',
              type: "error",
          })
          }

        })
        .catch(err => {
          showNotification({
            message:err.name || 'Check you Network, and Try again',
            type: "error",
        })

        })
    }
    
  }
  return (
    <Box component="form" className={css.form} onSubmit={handleSubmit}>
      <Typography component="h1" children={"Forgot Password"} 
        sx={{fontWeight:"bold",color:"white",fontSize:"22px"}} align="center" 
      />
      <Typography component="p" children={"Send password reset link to email"} 
        sx={{color:lightText,fontSize:"12px"}} align="center" mt={1} mb={5}
      />
      <label>
      <div>E-mail</div>
        <input type="text" value={Email} onChange={(e:any)=>setEmail(e.target.value)} placeholder='Enter Your e-email' />
        <span data-testid='span'><EmailIcons /></span>
      </label>
      {/* <input type="submit" value="Continue" /> */}
      <input 
        type="submit" 
        role='button' 
        style={{cursor:"pointer"}}
        data-testid ='ForgotPassword'
      />
      

    </Box>
  )
}

export default ForgotPassword;